/* eslint-disable */

import Phaser from 'phaser';
import { store } from "../stores/mainStore";
import { angleBetweenPoints, getDistance, pointAlongLine } from "./helpers";
var m;
export class Cup {

	constructor(mgr){
		// console.log(mgr)
		m = mgr;
		store.m = m;
		this.cupSprite = null;
		this.cupHomeposition =  {x: m.config.width/(m.landscape ? 4 : 3), y: (m.config.height * 0.66)-0};
		this.cupHomeposition.y += m.pushDownAmount;
		this.cupReleasePosition = this.cupHomeposition;
		this.cupDownPosition = this.cupReleasePosition;
		this.diceLaunchPosition = this.cupReleasePosition;
		this.cupClicked = false;
	}

	create(){
		this.cupSprite = m.scene.add.sprite(-100, m.config.height+100, 'cup_sheet').setInteractive();
		store.activeDebug = "active";
		this.setFrame(1);
		var myScale = 1.0;
		if(this.cupSprite.width != 180)
			myScale = 180/this.cupSprite.width;
		myScale *= m.scaleFactor;
		this.cupScale = myScale;
		this.cupSprite.setScale(myScale);	//force to be the size it was before in case of higher res source
		this.cupSprite.setOrigin(0.5, 0.05);
		this.cupSprite.inputEnabled = true;
		this.cupHeight = this.cupSprite.height * this.cupSprite.scaleY;
		this.cupSprite.input.draggable = true;
		
		this.arrowSprite = m.scene.add.sprite(this.cupHomeposition.x, this.cupHomeposition.y, 'common', 'cupArrow.png');
		this.arrowSprite.setOrigin(0.5, 1.1);
		this.cupSwirl = m.scene.add.sprite(this.cupSprite.x, this.cupSprite.y, 'swirl001');
		this.cupSwirl.setScale(m.oldAssetScaleFactor);
		this.cupSwirl.setOrigin(0.5, 0.275);
		this.waitForHandPointer = false;

		m.scene.input.setDraggable(this.cupSprite);
		// m.scene.input.on('dragstart', function (pointer, gameObject) {
		this.cupSprite.on('dragstart', (pointer) => {
			// if(gameObject != this.cupSprite) { // eslint-disable-line
			// 	return;
			// }
			if(m.cup.waitForHandPointer === true)
				return;
			console.log("DRAG START");

			if(m.handPointer){
				if(m.handPointerTimer)
					clearTimeout(m.handPointerTimer);
				m.handPointer.destroy();
			}

			m.cup.clearCupDragAutoFireTimer();
			m.cup.startCupDragAutoFireTimer();

			if(!m.cup.cupClicked)
				this.processPointerDown(pointer);
		});
		m.scene.input.on('drag', (pointer, gameObject, dragX, dragY) => {
		// this.cupSprite.on('drag', (pointer, gameObject, dragX, dragY) => {
			if(gameObject != this.cupSprite) { // eslint-disable-line
				return;
			}
			if(m.cup.waitForHandPointer === true)
				return;

			m.cup.clearCupDragAutoFireTimer();

			if(m.handPointer){
				if(m.handPointerTimer){
					clearTimeout(m.handPointerTimer);
				}
				m.handPointer.destroy();
			}

			// console.log("pointer: "+pointer.position.x+" , "+pointer.position.y+" draggable: "+m.cup.cupSprite.input.draggable);
			if(m.diceStatus === 'introToCup')
				return;
			if(m.diceStatus === 'launch' || m.diceStatus === 'launching')
				return;

			if(store.tutorialMode && m.skipTutorial != null)
				m.skipTutorial.setAlpha(0);


			let flickDistance = -m.cup.cupHeight/2;// -m.config.height * 0.02;
			// let pullDistance = m.config.height * 0.12;
			let pullDistance = (m.config.height - m.cup.cupHeight / 2) - m.cup.cupHomeposition.y;
			let yDistance = this.cupSprite.y - this.cupHomeposition.y;


			if(m.cup.cupSprite.y >= (this.cupHomeposition.y + flickDistance * 1.0))// (m.cup.cupDownPosition.y+2))
				gameObject.x = dragX;

			// if(dragY > m.config.height / 2.25)
			if(dragY >= (this.cupHomeposition.y + flickDistance) && dragY <= (this.cupHomeposition.y + pullDistance)) {
				gameObject.y = dragY;
				// gameObject.x = dragX;
			}
			this.pointCupTowardsAimPoint();

			let txt = 'flickDist: '+flickDistance+' pullDist: '+pullDistance+' yDist: '+yDistance+ ' will be ' + (this.cupSprite.y >= this.cupHomeposition.y ? 'PULL/TAP' : 'FLICK');

			// m.showCupDebugInfo = true;
			// this.updateCupDebugInfo(txt);

			// if(yDistance <= flickDistance) {
			// 	this.processCupPointerUp('FLICK_LIMIT');
			// 	return
			// }
			// if(yDistance >= pullDistance) {
			// 	this.processCupPointerUp('PULL_LIMIT');
			// 	return
			// }
			// console.log("cupX "+this.cupSprite.x+" cupY "+this.cupSprite.y);


			if(true) {
				m.cup.clearCupDragAutoFireTimer();

				var x = pointer.position.x;
				var y = pointer.position.y;
				var l = store.tutorialMode ? 40 : 20;
				var r = store.tutorialMode ? 40 : 40;

				var left = x < l;
				var right = x > (m.config.width-r);
				// var bottom = y > (m.config.height-l);
				var bottom = y > (m.config.height-m.cup.cupHeight * 0.3);
				var high = dragY < m.config.height * 0.15;
				if(left || right || bottom || high) {
					this.processCupPointerUp(left ? 'LEFT' : right ? 'RIGHT' : bottom ? 'BOTTOM' : 'HIGH');
					return;
				}

				var inBounds = Phaser.Geom.Rectangle.ContainsPoint(m.cup.cupSprite.getBounds(), pointer.position);
				if(inBounds === false) {
					this.processCupPointerUp('DRAG_OUT');
					return;
				}

				m.cup.startCupDragAutoFireTimer();
			}

		});
		// m.scene.input.on('dragend', (pointer, gameObject) => {
		this.cupSprite.on('dragend', (pointer) => {
			// if(gameObject != this.cupSprite) { // eslint-disable-line
			// 	return;
			// }
			if(m.diceStatus === 'introToCup')
				return;
			if(m.readyToLaunch || m.diceStatus !== 'arrivedInCup')
				return;

			this.processCupPointerUp('DRAGEND');
		});

		this.cupSprite.on('pointerdown', (pointer) => {
			this.processPointerDown(pointer);
		});
		this.cupSprite.on('pointerup', (pointer) => {
			this.processCupPointerUp('CUP_POINTERUP');
		});

		this.cupSprite.on('pointerout', (pointer) => {
			console.log("POINTEROUT");

			pointer = m.scene.input.activePointer;
			// // if (pointer.isDown)
			// var inBounds = Phaser.Geom.Rectangle.ContainsPoint(m.cup.cupSprite.getBounds(), pointer.position);
			// if(m.cup.cupClicked === true && inBounds === false)
			{
				// this.processCupPointerUp('POINTEROUT X: '+pointer.x.toFixed(2)+' Y: '+pointer.y.toFixed(2));
			}

		});

		this.pointCupTowardsAimPoint()
		this.arrowSprite.setScale(1.0*m.scaleFactor, 0);

		m.scene.input.on('pointerup', function(pointer){
			if(m.cup && m.cup.cupSprite && m.cup.cupSprite.input)
				m.cup.cupSprite.input.draggable = true;
		});

		m.scene.input.dragDistanceThreshold = 4;
		m.scene.input.dragTimeThreshold = 50;

		//STAGETEST
		m.scene.input.dragDistanceThreshold = 1;
		m.scene.input.dragTimeThreshold = 1;

	} //create();

	setFrame(frameNum) {
		this.frameNum = frameNum;
		this.cupSprite.setFrame(frameNum);
	}
	showDiceInCup() {
		if(m.cup.frameNum < 6)
			m.cup.setFrame(m.cup.frameNum+6);	//show same cup w/ little dice showing
	}
	hideDiceInCup() {
		if(m.cup.frameNum >= 6)
			m.cup.setFrame(m.cup.frameNum-6);	//show same cup w/ no little dice showing
	}
	doCupDragAutoFireTimer() {
		if(m.cupDragAutoFireTimer != null)
			m.cup.processCupPointerUp('TIMER');
	}
	startCupDragAutoFireTimer() {
		// m.cupDragAutoFireTimer = gameSetTimeout(m.cup.doCupDragAutoFireTimer, 1000);
	}
	clearCupDragAutoFireTimer() {
		if(m.cupDragAutoFireTimer != null) {
			clearTimeout(m.cupDragAutoFireTimer);
			m.cupDragAutoFireTimer = null;
		}
	}
	doCupNoticeMeTimer() {
		if(m.cupNoticeMeTimer != null) {
			m.cup.cupSprite.setScale(m.cup.cupScale);	
			var evapTween = m.scene.tweens.add({
				targets		: [ m.cup.cupSprite ],
				scaleX		: m.cup.cupScale * 1.2,
				scaleY		: m.cup.cupScale * 1.2,
				ease			: 'Linear',
				delay			: 0,
				duration		: 150,
				yoyo			: true,
				repeat		: 0,
				onComplete: (tween, target) => {
					m.cup.cupSprite.setScale(m.cup.cupScale);	
					var evapTween = m.scene.tweens.add({
						targets		: [ m.cup.cupSprite ],
						scaleX		: m.cup.cupScale * 1.2,
						scaleY		: m.cup.cupScale * 1.2,
						ease			: 'Linear',
						delay			: 50,
						duration		: 150,
						yoyo			: true,
						repeat		: 0,
						onComplete: (tween, target) => {
							m.cup.cupSprite.setScale(m.cup.cupScale);	
							m.cup.startCupNoticeMeTimer();
						}
					});		
				}
			});
		}
	}
	startCupNoticeMeTimer() {
		m.cup.cupSprite.setScale(m.cup.cupScale);	
		m.cupNoticeMeTimer = gameSetTimeout(m.cup.doCupNoticeMeTimer, 10000);
	}
	clearCupNoticeMeTimer() {
		m.cup.cupSprite.setScale(m.cup.cupScale);	
		if(m.cupNoticeMeTimer != null) {
			clearTimeout(m.cupNoticeMeTimer);
			m.cupNoticeMeTimer = null;
		}
	}

	cupDebugInfo = null;
	updateCupDebugInfo(txt) {
		if(!m.cup || !m.showCupDebugInfo)// || !m.cup.cupSprite || !m.cup.cupSprite.input)
			return;
		let touched = m.cup.cupClicked ? 'true' : 'false';
		let readyRoll = m.readyToRoll ? 'true' : 'false';
		let readyLaunch = m.readyToLaunch ? 'true' : 'false';
		let waitHandPointer = m.cup.waitForHandPointer ? 'true' : 'false';
		let dist = getDistance(m.cup.cupSprite.x, m.cup.cupSprite.y, m.cup.cupHomeposition.x, m.cup.cupHomeposition.y);
		let msg = 'cupClicked: '+ touched + ' waitForHP: '+waitHandPointer+' ready2Roll: '+readyRoll+' ready2launch: '+readyLaunch+'\n m.diceStatus: '+m.diceStatus+' distFromHome: '+dist+'\n'+txt;
	
		if(m.cup.cupDebugInfo === null) {
			// m.cup.cupDebugInfo.destroy();
			m.cup.cupDebugInfo = m.scene.add.text(5, m.config.height-100,'', { fontFamily: m.ui.dodFontFamily, fontSize: '24px', fill: '#ffffff', stroke: '#0', strokeThickness: 2, wordWrap: { width: 800 } });
			m.cup.cupDebugInfo.setOrigin(0.0,0.5);
			m.cup.cupDebugInfo.setDepth(8);
		}
		// if(m.cup.cupDebugInfo === null) {
		// 	m.cup.cupDebugInfo = m.scene.add.text(5, m.config.height-20,msg, { fontFamily: m.ui.dodFontFamily, fontSize: '16px', fill: '#ffffff', stroke: '#0', strokeThickness: 2, wordWrap: { width: 800 } });
		// 	m.cup.cupDebugInfo.setOrigin(0.0,0.5);
		// 	m.cup.cupDebugInfo.setDepth(8);
		// } else 
		{
			m.cup.cupDebugInfo.text = msg;
			// console.log('*******'+msg);
		}
	}
	processPointerDown(pointer) {
		if(m.diceStatus === 'introToCup')
			return;
		if(!m.readyToRoll)
			return;
		if(m.cup.waitForHandPointer === true)
			return;

		console.log("POINTER DOWN");
		// if(m.cup.cupClicked)
		// 	return;

		m.cup.cupSprite.input.draggable = true;
		m.cup.cupClicked = true;

		m.cup.cupDownPosition = {x: m.cup.cupSprite.x, y:m.cup.cupSprite.y};

		if(m.cupNoticeMeTimer != null)
			clearTimeout(m.cupNoticeMeTimer);

		if(m.handPointer){
			if(m.handPointerTimer){
				clearTimeout(m.handPointerTimer);
			}
			m.handPointer.destroy();
		}
		if(m.rollBannerTimer)
			clearTimeout(m.rollBannerTimer);

		store.tutorialState = '';
		m.startThrow(pointer);

		m.cupSwirlTimer = gameSetTimeout(m.cup.showCupSwirl, 400);
	}
	processCupPointerUp(reason) {
		this.cupClicked = false;
		m.cup.clearCupDragAutoFireTimer();

		this.arrowSprite.setScale(1.0*m.scaleFactor, 0);

		if(m.readyToLaunch || m.diceStatus === 'launch' || m.diceStatus === 'launching')
			return;
		// m.text.text = "Last Bet: "+store.user.lastBetAmount + " balance: "+store.user.balance;// "pointerup";


		// var debugInfo = m.scene.add.text(10, m.config.height-30,'FIRING: '+reason+' cupX: '+this.cupSprite.x.toFixed(2)+' cupY: '+this.cupSprite.y.toFixed(2), { fontFamily: m.ui.dodFontFamily, fontSize: '16px', fill: '#ffffff', stroke: '#0', strokeThickness: 2 });
		// debugInfo.setOrigin(0.0,0.5);
		// debugInfo.setDepth(8);
		// m.scoreCardElements.push(debugInfo);


		m.gameState.state = "roll";
		if(m.diceStatus === 'arrivedInCup') {
			m.diceStatus = 'launch';
			this.launchCup();
		} else
			m.readyToLaunch = true;

		// this.arrowSprite.setScale(1.0*m.scaleFactor, 0);

		this.hideCupSwirl();

		//DEBUG TOUCH
		// this.cupSprite.input.draggable = false;

		// this.cupSprite.disableInteractive();
	}
	showCupSwirl() {
		if(!m.cup.cupSwirl)
			return;
		m.cup.cupSwirl.x = m.cup.cupSprite.x;
		m.cup.cupSwirl.y = m.cup.cupSprite.y;
		m.cup.cupSwirl.angle = m.cup.cupSprite.angle;
		m.cup.cupSwirl.setAlpha(1.0);
		m.cup.cupSwirl.anims.play('cupSwirl');

		m.cup.clearCupDragAutoFireTimer();
		m.cup.startCupDragAutoFireTimer();

		m.cup.pointCupTowardsAimPoint();
	}
	hideCupSwirl() {
		if(!m.cup.cupSwirl)
			return;
		if(m.cupSwirlTimer != null) {
			clearTimeout(m.cupSwirlTimer);
			m.cupSwirlTimer = null;
		}
		this.cupSwirl.setAlpha(0);
		if(!this.cupSwirl.anims)
			return;
		this.cupSwirl.anims.stop();

		this.arrowSprite.setScale(1.5* m.scaleFactor, 0);
	}
	pointCupTowardsAimPoint() {
		this.cupSprite.angle = angleBetweenPoints({x:this.cupSprite.x, y:this.cupSprite.y}, m.aimPoint) - 90;
		this.arrowSprite.x = this.cupSprite.x;
		this.arrowSprite.y = this.cupSprite.y;
		this.arrowSprite.angle = this.cupSprite.angle;
		var distance = getDistance(this.cupSprite.x, this.cupSprite.y, m.aimPoint.x, m.aimPoint.y);
		var maxDistance = getDistance(m.farthestLaunchPoint.x, m.farthestLaunchPoint.y, m.aimPoint.x, m.aimPoint.y);
		var scale = distance / maxDistance;
		scale *= 2.0 * m.scaleFactor;
		if(scale > 1.75* m.scaleFactor)
			scale = 1.75* m.scaleFactor;
		if(scale < 0.5* m.scaleFactor)  
			scale = 0.5* m.scaleFactor;

		if(m.cup.cupSwirl && m.cup.cupSwirl.alpha > 0)
			this.arrowSprite.setScale(1.5* m.scaleFactor, scale);

		this.cupSwirl.x = this.cupSprite.x;
		this.cupSwirl.y = this.cupSprite.y;
		this.cupSwirl.angle = this.cupSprite.angle;
	}
	hideCup() {
		this.cupSprite.x = (this.cupSprite.x > m.config.width / 2) ? m.config.width + 400 : -400;
		this.cupSprite.y = m.config.height+400;
	}
	returnCup = () => {

		if(store.activeMatch.currentHand.rollsRemaining === 0 || store.activeMatch.currentHand.best) {
			m.nextHand();
		} else {
			if(store.tutorialMode) {

				// if(store.activeMatch.handNumber === 3 && store.activeMatch.currentHand.rollNumber === 1) {
				// 	store.tutorialState = 'handInfo';
				// 	//store.tutorialPreventRoll = true;
				// 	if(!store.tutorialMode){
				// 		m.ui.showZoomButton();
				// 	}
				// }
			}

			this.reallyReturnCup();
		}
	}
	setTutorialStateTwoPair() {
		m.ui.showTutorialBanner();
		store.tutorialState = 'twopair';
		// store.tutorialPreventRoll = true;
		// if(m.roundBanner != null)
		// 	m.roundBanner.destroy();
		// m.clearMessages();
		m.cup.waitForHandPointer = true;
		// gameSetTimeout(m.cup.clearWaitForHandPointer, 700);

		gameSetTimeout(m.cup.continueSetTutorialStateTwoPair, 1000);
	}
	continueSetTutorialStateTwoPair() {
		if(m.diceStatus === 'introToCup')
			m.diceStatus = 'resolved';

		m.cup.showHandPointer();
			// store.tutorialPreventRoll = false;
	}

	waitForHandPointer = false;
	setWaitForHandPointer(msecs) {
		this.waitForHandPointer = true;
		gameSetTimeout(m.cup.clearWaitForHandPointer, msecs);
	}
	clearWaitForHandPointer() {
		m.cup.waitForHandPointer = false;
	}

	reallyReturnCup(noZoom) {

		if(store.tutorialMode && store.tutorialPreventRoll){
			return;
		}

		var frameNum = (store.activeMatch.currentHand.rollNumber >= 3 && !store.isEligibleForRewardRoll) ? 4 : store.activeMatch.currentHand.rollsRemaining;
		this.setFrame(frameNum);
		var cupOffset = m.landscape? 0.25 : 0.33;
		this.cupHomeposition.x = (this.cupSprite.x > m.config.width / 2) ? m.config.width * (1.0 - cupOffset) : m.config.width * cupOffset;
		var angle = angleBetweenPoints({x:this.cupHomeposition.x, y:this.cupHomeposition.y}, m.aimPoint) - 90;

		if(store.tutorialMode){
			if(store.activeMatch.handNumber === 1 && store.activeMatch.currentHand.rollNumber === 0){
				// store.tutorialPreventRoll = true;
				// gameSetTimeout(m.cup.setTutorialStateTwoPair, 1000);
				if(m.diceHand.areDiceOffScreen())
					m.cup.showDiceInCup();
				m.cup.setTutorialStateTwoPair();
				return;
			}
		}

		m.cup.cupSprite.x = (m.cup.cupSprite.x > m.config.width / 2) ? m.config.width + 100 : -100;
		// m.cup.cupSprite.x = -100;
		m.cup.cupSprite.y = m.config.height+100;

		let handPointerWillShow = store.tutorialMode && !(store.activeMatch.handNumber === 3 && store.activeMatch.currentHand.rollNumber > 0);
		if(handPointerWillShow) {
			m.cup.waitForHandPointer = true;
			// gameSetTimeout(m.cup.clearWaitForHandPointer, 700);
		}

		// if(m.cup.cupDebugInfo || m.cup.cupDebugInfo != null)
		// 	m.cup.cupDebugInfo.destroy();
		// m.cup.cupDebugInfo = m.scene.add.text(5, m.config.height-20,'', { fontFamily: m.ui.dodFontFamily, fontSize: '16px', fill: '#ffffff', stroke: '#0', strokeThickness: 2, wordWrap: { width: 800 } });
		// m.cup.cupDebugInfo.setOrigin(0.0,0.5);
		// m.cup.cupDebugInfo.setDepth(8);

		// m.showCupDebugInfo = true;

		m.scene.tweens.add({
			targets     : [ this.cupSprite ],
			x: this.cupHomeposition.x,
			y: this.cupHomeposition.y,
			angle: angle,
			//   ease        : 'Expo.easeIn',
			ease		  : 'Linear',
			duration    : 300,
			repeat      : 0,
			completeDelay: 0,
			onComplete: (tween, target /*,num*/) => {
				// console.log("TWEEN: cup returned ");

				if(m.diceHand.areDiceOffScreen())
					m.cup.showDiceInCup();

				if(store.tutorialMode){
					if(store.activeMatch.currentHand.rollNumber === 0)
						m.ui.showTutorialBanner();
					if(handPointerWillShow)
						this.showHandPointer();
				} else {
					// m.handPointerTimer = gameSetTimeout(() => {
					// 	this.showHandPointer();
					// }, 3000);
					this.startCupNoticeMeTimer();
				}

				// if(!store.tutorialMode)
				// {
				// 	let already = m.ui.previousUserProfilePicLoaded ? 'true' : 'false';
				// let cupDebugInfo = m.scene.add.text(5, m.config.height-20,'already: '+already+' image: '+store.user.image, { fontFamily: m.ui.dodFontFamily, fontSize: '12px', fill: '#ffffff', stroke: '#0', strokeThickness: 2, wordWrap: { width: 400 } });
				// cupDebugInfo.setOrigin(0.0,0.5);
				// cupDebugInfo.setDepth(8);
				// m.scoreCardElements.push[cupDebugInfo];
				// }

				// if(store.tutorialMode){
				// 	if(store.activeMatch.currentHand.rollNumber === 1){
				// 		store.tutorialState = 'waitforjacks'
				// 	}
				// 	if(store.activeMatch.currentHand.rollNumber === 2){
				// 		store.tutorialState = 'waitforwild'
				// 	}
				// }
				if(m.diceStatus !== "resolved" || store.activeMatch.currentHand.rollNumber === 0 || store.activeMatch.currentHand.rollsRemaining < 1 || store.activeMatch.currentHand.best)
					return;

				if(!store.tutorialMode){//} || store.activeMatch.handNumber === 2){
					if(store.activeMatch.currentHand.rollNumber > 0){
						m.ui.showSelectDiceMsg();
						m.ui.showZoomButton();
					}
				}
			},
			//   onCompleteParams: [d.diceNum],
		});
	}

	// fakeReturnCup() {
	// 	m.diceStatus = 'introToCup';
	// 	m.diceHand.endIntroDiceIntoCup();
	// 	return;
	// }

	reallyFakeReturnCup(animate) {
		var frameNum = store.activeMatch.currentHand.rollNumber >= 3 ? 4 : store.activeMatch.currentHand.rollsRemaining;
		this.setFrame(frameNum);
		var cupOffset = m.landscape? 0.25 : 0.33;
		this.cupHomeposition.x = (this.cupSprite.x > m.config.width / 2) ? m.config.width * (1.0 - cupOffset) : m.config.width * cupOffset;
		var angle = angleBetweenPoints({x:this.cupHomeposition.x, y:this.cupHomeposition.y}, m.aimPoint) - 90;

		m.cup.cupSprite.x = (m.cup.cupSprite.x > m.config.width / 2) ? m.config.width + 100 : -100;
		// m.cup.cupSprite.x = -100;
		m.cup.cupSprite.y = m.config.height+100;

		if(store.tutorialMode) {
			if(store.activeMatch.matchId === 'intro' && m.diceStatus != 'introToCup')
				m.cup.showDiceInCup();
			else
				if(store.activeMatch.matchId != 'intro' && m.diceHand.areDiceOffScreen())
					m.cup.showDiceInCup();
		}

		if(animate) {
			m.scene.tweens.add({
				targets     : [ this.cupSprite ],
				x: this.cupHomeposition.x,
				y: this.cupHomeposition.y,
				angle: angle,
				//   ease        : 'Expo.easeIn',
				ease		  : 'Linear',
				duration    : 300,
				repeat      : 0,
				completeDelay: 0,
				onComplete: (tween, target /*,num*/) => {
					// console.log("TWEEN: cup returned ");
					// m.diceHand.introDiceIntoCup();
				},
				//   onCompleteParams: [d.diceNum],
			});
		} else {
			this.cupSprite.x = this.cupHomeposition.x;
			this.cupSprite.y = this.cupHomeposition.y;
			this.angle = angle;
			if(store.tutorialMode && store.activeMatch.matchId === 'intro') {
				m.cup.showHandPointer();
				// gameSetTimeout(m.cup.clearWaitForHandPointer, 500);
			}
		}
	}

	handPointerFlick = false;
	showHandPointer() {
		if(m.handPointer) {
			m.handPointer.destroy();
			// m.cupOutline.destroy();
		}
		// return;

		if(m.diceStatus !== "resolved" || Math.floor(m.cup.cupSprite.x) !== Math.floor(m.cup.cupHomeposition.x) || Math.floor(m.cup.cupSprite.y) !== Math.floor(m.cup.cupHomeposition.y))
			return;
		if((store.activeMatch.handNumber === 3 && store.activeMatch.currentHand.rollNumber > 0))
			return;

		m.cup.handPointerFlick = !m.cup.handPointerFlick;

		m.handPointer = m.scene.add.container(m.cup.cupHomeposition.x, m.cup.cupHomeposition.y);

		var cupOutline = m.scene.add.sprite(0, 0, 'common', 'cupOutline.png');
		cupOutline.setOrigin(0.47, 0.15);
		cupOutline.setScale(m.cup.cupSprite.scale);
		cupOutline.angle = m.cup.cupSprite.angle;
		m.handPointer.add(cupOutline);

		var pointerHand = m.scene.add.sprite((m.cup.cupHomeposition.x > m.config.width / 2 ? 110 *m.scaleFactor : 70*m.scaleFactor), 120*m.scaleFactor, 'hand');
		pointerHand.setScale(0.65*m.scaleFactor);
		m.handPointer.add(pointerHand);
		pointerHand.anims.play('handPoint');
		// pointerHand.setFrame(1);

		// if(!(store.tutorialMode && store.activeMatch.matchId === 'intro'))
			m.cup.waitForHandPointer = false;

		if(m.cup.handPointerFlick) { 
			var deltaX = 50;// * m.scaleFactor;
			var targetX = m.cup.cupHomeposition.x > m.config.width / 2 ? + -deltaX : deltaX;
			var targetY = -m.cup.cupSprite.height;
			var oldX = cupOutline.x, oldY = cupOutline.y;
			var thisTween = m.scene.tweens.add({
				targets     : [ cupOutline ],
				x: targetX,
				y: targetY,
				ease        : 'Linear',
				delay		: 1000,
				duration    : 150,
				repeat      : 0,
				completeDelay: 0,
				onComplete: (tween, target) => {

					if(store.tutorialMode && store.activeMatch.matchId === 'intro')
						m.cup.waitForHandPointer = false;

					var deltaX = 10;// * m.scaleFactor;
					var tx = m.cup.cupHomeposition.x > m.config.width / 2 ? (targetX + deltaX) : (targetX-deltaX);
					var ty = -m.cup.cupSprite.height * 0.75;
					var oldX = cupOutline.x, oldY = cupOutline.y;
					var thisTween = m.scene.tweens.add({
						targets     : [ cupOutline ],
						x: tx,
						y: ty,
						ease        : 'Linear',
						duration    : 150,
						yoyo		: true,
						repeat      : 0,
						completeDelay: 0,
						onComplete: (tween, target) => {
							m.handPointerTimer = gameSetTimeout(m.cup.showHandPointer, 1000);
						}
					});
				}
			});
			var offsetX = m.cup.cupHomeposition.x > m.config.width / 2 ? + -deltaX : deltaX;
			var targetX2 = pointerHand.x + offsetX;
			var targetY2 = pointerHand.y - m.cup.cupSprite.height;
			var oldX2 = pointerHand.x, oldY2 = pointerHand.y;
			m.scene.tweens.add({
				targets     : [ pointerHand ],
				x: targetX2,
				y: targetY2,
				ease        : 'EaseOut',
				// ease		  : 'Linear',
				delay		: 1000,
				duration    : 150,
				repeat      : 0,
				completeDelay: 0,
				onComplete: (tween, target) => {
					pointerHand.setFrame(0);

					// m.scene.tweens.add({
					// 		targets     : [ pointerHand ],
					// 		x: oldX2,
					// 		y: oldY2,
					// 		//   ease        : 'Expo.easeIn',
					// 		ease		  : 'Linear',
					// 		delay		: 750,
					// 		duration    : 750,
					// 		repeat      : 0,
					// 		completeDelay: 0
					// 	});
				}
			});
		} else {
			var deltaX = 60;// * m.scaleFactor;
			var targetX = m.cup.cupHomeposition.x > m.config.width / 2 ? + deltaX : -deltaX;
			var targetY = m.cup.cupSprite.height;
			var oldX = cupOutline.x, oldY = cupOutline.y;
			var thisTween = m.scene.tweens.add({
				targets     : [ cupOutline ],
				x: targetX,
				y: targetY,
				ease        : 'EaseOut',
				// ease		  : 'Linear',
				delay		: 1000,
				duration    : 500,
				repeat      : 0,
				completeDelay: 0,
				onComplete: (tween, target) => {
					if(store.tutorialMode && store.activeMatch.matchId === 'intro')
						m.cup.waitForHandPointer = false;
					m.scene.tweens.add({
						targets     : [ cupOutline ],
						x: oldX,
						y: oldY,
						//   ease        : 'Expo.easeIn',
						ease		  : 'Linear',
						delay		: 250,
						duration    : 250,
						repeat      : 0,
						callbackScope   : thisTween,
						completeDelay: 0,
						onComplete: (tween, target) => {
							m.handPointerTimer = gameSetTimeout(m.cup.showHandPointer, 1000);
						}
					});
				}
			});
			var offsetX = m.cup.cupHomeposition.x > m.config.width / 2 ? + deltaX : -deltaX;
			var targetX2 = pointerHand.x + offsetX;
			var targetY2 = pointerHand.y + m.cup.cupSprite.height;
			var oldX2 = pointerHand.x, oldY2 = pointerHand.y;
			m.scene.tweens.add({
				targets     : [ pointerHand ],
				x: targetX2,
				y: targetY2,
				ease        : 'EaseOut',
				// ease		  : 'Linear',
				delay		: 1000,
				duration    : 500,
				repeat      : 0,
				completeDelay: 0,
				onComplete: (tween, target) => {
				pointerHand.setFrame(0);
				m.scene.tweens.add({
						targets     : [ pointerHand ],
						x: oldX2,
						y: oldY2,
						//   ease        : 'Expo.easeIn',
						ease		  : 'Linear',
						delay		: 750,
						duration    : 750,
						repeat      : 0,
						completeDelay: 0
					});
				}
			});
		}
	}

	launchCup = () => {
		m.playfieldStartScrolling();
		m.playAudio('diceRoll');

		m.cup.hideDiceInCup();

		store.tutorialState = '';
		var aimPoint = m.aimPoint;
		m.cup.cupReleasePosition = {x: m.cup.cupSprite.x, y:m.cup.cupSprite.y};
		var distance = getDistance(this.cupSprite.x, this.cupSprite.y, aimPoint.x, aimPoint.y);
		//if(getDistance(this.cupSprite.x, this.cupSprite.y, this.cupHomeposition.x, this.cupHomeposition.y) > 5 * m.scaleFactor /* && this.cupSprite.y > this.cupHomeposition.y */)
		//has cup moved enough for the 'launch' movement, or should dice just come out of cup
		 {
			// var homeDistanceFromAimPoint = getDistance(aimPoint.x, aimPoint.y, this.cupHomeposition.x, this.cupHomeposition.y);
			// homeDistanceFromAimPoint *= 0.75;
			// if(distance > homeDistanceFromAimPoint)
			 {
				// var targetPoint = pointAlongLine(1.0 - (homeDistanceFromAimPoint / distance), this.cupSprite.x, this.cupSprite.y, aimPoint.x, aimPoint.y);
				var travel = this.cupHeight * 1.5 / distance;
				if(travel > 0.9)
					travel = 0.9;
				var targetPoint = pointAlongLine(travel, this.cupSprite.x, this.cupSprite.y, aimPoint.x, aimPoint.y);
				var thisTween = m.scene.tweens.add({
					targets     : [ this.cupSprite ],
					x: targetPoint.x,
					y: targetPoint.y,
					//   ease        : 'Expo.easeIn',
					ease		  : 'Linear',
					duration    : 50,
					repeat      : 0,
					callbackScope   : thisTween,
						completeDelay: 0,
						onComplete: (tween, target /*,num*/) => {
							// console.log("TWEEN: cup moved now launching dice ", this.x, this.y);
							// WrapperApp.postMessage('haptic_vibrate');
							m.diceHand.launchDice();
						},
					//   onCompleteParams: [d.diceNum],
						onCompleteScope: thisTween,
					});
				return;
			}
		}

		gameSetTimeout(m.diceHand.launchDice, 50);
		// m.diceHand.launchDice();
	}
}
